import React, { useContext, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from '../components/header/Header';
import Menu from '../components/menu/Menu';
import { UserContext } from '../contexts/UserContext';

const AuthenticatedLayout = () => {
  const { user } = useContext(UserContext);
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [labelList, setLabelList] = useState([]);
  const [boardStatusList, setBoardStatusList] = useState([]);
  const [queryParams, setQueryParams] = useState({
    page: 1,
    limit: 12,
    filterField: null,
    filterValue: '',
    sortBy: '',
    sortOrder: 'asc',
    hospitalFilter: [],
    labelFilter: [],
    statusFilter: [],
    boardStatusFilter: [],
    expiringOnly: false,
    hideClean: false,
    open30plus: false,
  });
  

  const toggleSidebar = () => setSidebarOpen(prev => !prev);
  
  const hideMenu =
    location.pathname === '/ffc-report' || 
    location.pathname === '/ar-report' ||
    location.pathname === '/auth-form' ||
    location.pathname === '/rules-form' ||
    location.pathname === '/leadership-report' ||
    location.pathname === '/hierarchy-report' ||
    location.pathname === '/argus-report' ||
    location.pathname.startsWith('/visit/');

  return (
    <div className="app-wrapper">
      <Header user={user} toggleSidebar={toggleSidebar} />

      <div className="main-layout">
        {!hideMenu && (
          <Menu
            isOpen={sidebarOpen}
            user={user}
            labelList={labelList}
            labelFilter={queryParams.labelFilter}
            statusFilter={queryParams.statusFilter}
            boardStatusList={boardStatusList}          
            queryParams={queryParams}
            setQueryParams={setQueryParams}
          />
        )}

        <div className="body">
          <Outlet context={{
            labelList,
            setLabelList,
            boardStatusList,
            setBoardStatusList,        
            queryParams,
            setQueryParams
          }} />
        </div>
      </div>
    </div>
  );
};

export default AuthenticatedLayout;